<template>
  <a
    class="pdf-multimedia-card"
    :href="pdfLink"
    target="_blank"
    @mouseenter="toggeHovered"
    @mouseleave="toggeHovered"
    @click="pushPdf"
  >
    <img
      :src="`${$baseUrl}images/${
        smallscreen ? 'home' : 'download'
      }_pdf-cover-${locale}.webp`"
      alt=""
      class="pdf-multimedia-card__img"
    />

    <div class="pdf-multimedia-card__content">
      <ButtonDownload
        class="pdf-multimedia-card__content__button hover-content"
        :label="cta"
      />
      <div class="pdf-multimedia-card__content__title hover-content">
        {{ title }}
      </div>
      <CtaBar :cta="$t('general.ctas.download')" :hovered="hovered" />
    </div>
  </a>
</template>

<script setup>
import { ref, inject, computed } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";
import { useI18n } from "vue-i18n";
import { pushData } from "@/utilities/analytics-functions.js";

import CtaBar from "./CtaBar.vue";
import ButtonDownload from "./ButtonDownload.vue";

const props = defineProps({
  title: String,
  cta: String,
  pdfLink: String,
});

const { locale } = useI18n();
const $baseUrl = inject("$baseUrl");
const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));

const hovered = ref(false);

function toggeHovered() {
  hovered.value = !hovered.value;
}

function pushPdf() {
  pushData("pdf", props.pdfLink, "", props.cta);
}
</script>

<style lang="scss" scoped>
.pdf-multimedia-card {
  @include gradient-overlay;

  --card-width: var(--vw-no-scrollbar, 100vw) - var(--page-padding-h) * 2;

  color: var(--white-100);
  width: calc(var(--card-width));
  height: calc(var(--card-width) * 0.45);
  position: relative;
  overflow: hidden;
  // transform: translateY(50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;

  &__img {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    .mobile & {
      top: 0;
      transform: translateY(0);
    }
  }

  &__content {
    position: relative;
    z-index: 1;
    width: 100%;

    .hover-content {
      padding-left: 1.5rem;
      transition: transform 0.5s;
    }

    &__title {
      @include title-l;

      margin-top: 0.5rem;
    }
  }

  &:hover {
    .hover-content {
      transform: translateY(calc(var(--cta-bar-height) * -0.5));
    }
  }
}
</style>
